import { FC, Fragment } from 'react';

import * as Styles from './segment-parts.module.less';
import {
    DateRange,
    RecurringServiceEventStatus,
    ReferenceDto,
    RelativeDateRange,
} from '@servicetitan/application-data/marketing';
import {
    PerformDateRangeFilterSelector,
    PerformEnumMultiSelect,
    PerformMultiSelect,
    PerformRefdtoMultiSelect,
} from '../perform-indicator/perform-indicator';

interface SmsCampaignRecurringServicesProps {
    recurringServices?: string[] | undefined;
    recurringEventStatus?: RecurringServiceEventStatus[] | undefined;
    recurringEventDate?: DateRange | undefined;
    recurringEventDateRelative?: RelativeDateRange | undefined;
    technicians?: ReferenceDto[] | undefined;
}

export const SmsCampaignRecurringServices: FC<SmsCampaignRecurringServicesProps> = ({
    recurringServices,
    recurringEventStatus,
    recurringEventDate,
    recurringEventDateRelative,
    technicians,
}) => (
    <Fragment>
        <div className={Styles.segmentCardKpiName}>Recurring Service Events</div>
        <div>
            <PerformMultiSelect name="Recurring Service" value={recurringServices} />
            <PerformDateRangeFilterSelector
                name="Recurring Service Event Date"
                valueStatic={recurringEventDate}
                valueDynamic={recurringEventDateRelative}
            />
            <PerformEnumMultiSelect
                name="Recurring Service Event Status"
                value={recurringEventStatus}
                enumType={RecurringServiceEventStatus}
            />

            <PerformRefdtoMultiSelect name="Technician" value={technicians} />
        </div>
    </Fragment>
);
